import { render, staticRenderFns } from "./predefinedResponse.vue?vue&type=template&id=493a0c1c&scoped=true"
import script from "./predefinedResponse.vue?vue&type=script&lang=js"
export * from "./predefinedResponse.vue?vue&type=script&lang=js"
import style0 from "./predefinedResponse.vue?vue&type=style&index=0&id=493a0c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a0c1c",
  null
  
)

export default component.exports